































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { getCookie, dateFormat } from "@szgc/plt-core-v2";
import Api from "../../api/index";
import request from "../../api/request";
import { SzgcProcessGetor, SzgcMobileGetor } from "@/index";
import { PltSelect } from "@szgc/plt-ui-v2";
import FormGetor from "../../components/formGetor/index.vue";
import ExportDialog from "./ExportDialog.vue";
import SelectComponent from "../../../gt/components/DictSelectComponent/index.vue";
import LeftTree from "./components/LeftTree.vue";
import LoadingController from "../../api/loading_controller";
Vue.component("SzgcMobileGetor", SzgcMobileGetor);
Vue.component("SzgcProcessGetor", SzgcProcessGetor);
import { Loading } from 'element-ui';
Vue.use(Loading.directive);

@Component({
  name: "SzgcFormTable",
  components: {
    PltSelect,
    FormGetor,
    ExportDialog,
    SelectComponent,
    LeftTree
  }
})
export default class SzgcFormTable extends Vue {
  @Ref("exportDialog")
  private exportDialog!: ExportDialog;

  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: String,
    default: "default"
  })
  private type!: string;

  /*查询表格详情的id*/
  @Prop({
    type: [String, Number],
    default: ""
  })
  private viewId!: string;

  /*form的item宽度*/
  @Prop({
    type: Number,
    default: 3
  })
  private cols!: number;

  /*form的label宽度*/
  @Prop({
    type: [String, Number],
    default: "auto"
  })
  private labelWidth!: string;

  /*表格操作列宽度*/
  @Prop({
    type: [String, Number],
    default: "180px"
  })
  private lastWidth!: string;

  /*搜索栏大小*/
  @Prop({
    type: String,
    default: "mini"
  })
  private size!: string;

  /*表格是否能选择*/
  @Prop({
    type: Boolean,
    default: true
  })
  private isSelection!: boolean;

  /*表格单选还是多选*/
  @Prop({
    type: Boolean,
    default: false
  })
  private multiple!: boolean;

  @Prop({
    required: false,
    default: false
  })
  topShow!: boolean;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  private list!: any;

  private prefix: any = "";
  private currentUser: any = null;
  private isShow: boolean = false;
  private package: any = null;
  private formData: any = {};
  private tableHeight: any = 0;
  private hasSearch: boolean = false;
  private hasFooter: boolean = true;
  private showSearch: boolean = false;
  private leftHeight: string = "0px";
  private formActionsHeight: number = 0;
  private searchItemHeight: number = 0;
  private pltTableSearchFormHeight: number = 0;
  /*搜索条件相关--start--*/
  private pageConditions: any = [];
  /*搜索条件相关--end--*/
  /*表格相关--start--*/
  private tableThead: any = [];
  private excelHeaders: any = [];
  private tableData: any = [];
  private events: any = {
    total: 0,
    pageSize: 15,
    current: 1
  };
  /*表格相关--end--*/
  /*选择器相关--start--*/
  private isSelectShow: boolean = false;
  private showSelectComponent: boolean = false;
  private nowInputItem: any = null;
  private nowInputFileName: any = null;
  private selectType: any = "";
  private limiter: any = "";
  private selected: any = "";
  /*选择器相关--end--*/
  private flowConfigId: any = "";
  private flowList: any = [];
  private ifProcess: boolean = false;
  /*无流程表单相关--start--*/
  private modalShow: boolean = false;
  private modalData: any = null;
  private modalTitle: string = "";
  private preShow: boolean = false;
  /*无流程表单相关--end--*/
  /*流程表单相关--start--*/
  private processTitle: any = "";
  private processShow: boolean = false;
  private flowInfo: any = {};
  private proDetailShow: boolean = false;
  private processDetail: any = null;
  private processType: string = "mine";
  private checkedList: any[] = [];
  private selections: any[] = [];
  private labelKey: string = "";
  private isFirstIn: boolean = true; //首次调用组件
  private selectConditions: any[] = [];
  private selectComponentCode: string = "";
  private selectedDict: string[] = [];

  /*流程表单相关--end--*/
  private timer: any = null;

  private loadingController = Object.freeze(LoadingController);

  @Watch("viewId", { immediate: true, deep: true })
  private getData(newVal: any) {
    this.prefix = getCookie("plt-api-route") || "";
    if (newVal) {
      this.getCurrent();
    }
  }

  /*表格行选择 !!!!todo*/
  // selectable(row: any, index: number) {
  //   if (this.type === "view") {
  //     return index % 2 === 0;
  //   } else {
  //     return true;
  //   }
  // }

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  get computedTreeSearch() {
    return this.pageConditions.find((item: any) => item.searchCfgVo?.ifPrimarySearch);
  }
  get computedPageConditions() {
    // return this.pageConditions;
    return this.pageConditions.filter((item: any) => !item.searchCfgVo?.ifPrimarySearch);
  }
  private primarySearchValue: any = null;
  handleNodeClick(value: any) {
    this.primarySearchValue = value;    
    this.searchEvt();
  }

  /*获取当前登录人信息*/
  async getCurrent() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + "/secure/current",
        method: "get"
      });
      if (!success) {
        return this.$message.error("获取当前用户信息失败:" + message);
      }
      if (data) {
        this.currentUser = data;
        this.getViewInfo();
      }
    } catch (e) {
      this.$message.error("获取当前用户信息失败:" + e);
    }
  }

  /*查询流程包信息*/
  async getViewInfo() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getViewInfo(this.viewId),
        method: "get"
      });
      if (!success) {
        this.$message.error("查询流程包信息失败:" + message);
      }
      this.package = data;
      this.ifProcess = this.package.packageInfo.ifProcess;
      this.getConditions();
    } catch (error: any) {
      this.$message.error("查询流程包信息失败:" + error);
    }
  }

  /*通过id获取搜索条件*/
  async getConditions() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getConditions(this.viewId),
        method: "get"
      });
      if (!success) {
        this.$message.error("获取搜索条件失败:" + message);
      }
      this.handleSearch(data);
      this.initFormData();
      this.getTableData();
    } catch (error: any) {
      this.$message.error("获取搜索条件失败:" + error);
    }
  }

  /*渲染搜索条件*/
  handleSearch(data: any) {
    let source: any = data;
    let temp: any = [];
    source.map((item: any) => {
      const itemClone = JSON.parse(JSON.stringify(item));
      if (itemClone.propertyType === "boolean") {
        //把搜索条件按照类型分类
        itemClone.list = [
          { label: "全部", value: "" },
          { label: "是", value: "1" },
          { label: "否", value: "2" }
        ];
        itemClone.inputType = "select";
        temp.push(itemClone);
      } else if (itemClone.propertyType === "date") {
        itemClone.inputType = "date";
        temp.push(itemClone);
      } else if (
        itemClone.propertyType === "longText" ||
        itemClone.propertyType === "shortText" ||
        itemClone.propertyType === "serial" ||
        itemClone.propertyType === "code"
      ) {
        itemClone.inputType = "input";
        temp.push(itemClone);
      } else if (
        itemClone.propertyType === "integer" ||
        itemClone.propertyType === "long" ||
        itemClone.propertyType === "numerical"
      ) {
        itemClone.inputType = "number";
        temp.push(itemClone);
      } else {
        itemClone.inputType = "click";
        temp.push(itemClone);
      }
    });
    this.pageConditions = [...temp];
    this.hasSearch = this.pageConditions.length > 0;
    // // 计算表格box高度
    // this.$nextTick(() => {
    //   const parentHeight: any = (this.$refs.pltTablePage as HTMLDivElement).getBoundingClientRect();
    //   const searchHeight: any = (
    //     this.$refs.pltTableSearch as HTMLDivElement
    //   ).getBoundingClientRect();
    //   this.tableHeight = parentHeight.height - searchHeight.height - 10 + "px";

    //   if (this.hasSearch) {
    //     this.leftHeight = searchHeight.height + "px";
    //   } else {
    //     this.leftHeight = "0px";
    //   }
    // });
    this.$nextTick(() => {
      if (
        Array.isArray(this.$refs.pltTableSearchItem) &&
        this.$refs.pltTableSearchItem.length > 0
      ) {
        const searchItemClientRect = (
          this.$refs.pltTableSearchItem[0] as Vue & { $el: () => HTMLElement }
        ).$el.getBoundingClientRect();
        const pltTableSearchFormClientRect = (
          this.$refs.pltTableSearchForm as Vue & { $el: () => HTMLElement }
        ).$el.getBoundingClientRect();
        const formActions = this.$refs.formActions as HTMLElement;
        const formActionsClientRect = formActions.getBoundingClientRect();

        this.searchItemHeight = Math.ceil(searchItemClientRect.height);
        this.pltTableSearchFormHeight = Math.ceil(pltTableSearchFormClientRect.height);
        this.leftHeight = searchItemClientRect.height + 2 + "px";
        this.formActionsHeight = Math.ceil(formActionsClientRect.height);
      }
    });
  }

  /*初始化搜索条件*/
  initFormData() {
    let formObj: any = {};
    this.pageConditions.map((item: any) => {
      formObj[item.propertyName] = JSON.parse(JSON.stringify(item));
      if (item.inputType === "click") {
        //如果是点击选择的，必须要新增另一个字段用来存储对应code
        formObj[item.propertyName].inputType = item.inputType;
        formObj[item.propertyName].valueText = "";
        formObj[item.propertyName].text = "";
      } else {
        formObj[item.propertyName].inputType = item.inputType;
        formObj[item.propertyName].value = "";
      }
    });
    this.formData = formObj;
  }

  /*查询表格数据*/
  async getTableData() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.hasFooter = this.package.viewConfig.ifPage === 1; //是否有分页
    let searchParams: any = [];
    if (this.hasSearch) {
      //有搜索条件(无搜索条件, searchParams传空数组)
      for (let attr in this.formData) {
        let conditionValue: any = "";
        if (this.formData[attr]["inputType"] === "date") {
          let start: any = "",
            end: any = "";
          if (
            this.formData[attr].value &&
            this.formData[attr].value.length &&
            this.formData[attr].value.length > 0
          ) {
            start = this.formData[attr].value[0];
            end = this.formData[attr].value[1];
            if (typeof end === "number") {
              end = end + 24 * 60 * 60 * 1000 - 1000;
            }
          }
          conditionValue = start === "" ? null : start + "-" + end;
        } else if (this.formData[attr]["inputType"] === "select") {
          if (this.formData[attr]["value"] === "") {
            conditionValue = null;
          } else {
            conditionValue = this.formData[attr]["value"] === "1";
          }
        } else if (this.formData[attr]["inputType"] === "click") {
          conditionValue = this.formData[attr]["valueText"]
            ? this.formData[attr]["valueText"]
            : null;
        } else if (this.formData[attr]["inputType"] === "number") {
          if (this.formData[attr]["value"]) {
            if (isNaN(this.formData[attr]["value"] * 1)) {
              //判断是否为数字
              conditionValue = this.formData[attr]["value"];
            } else {
              conditionValue = this.formData[attr]["value"] * 1;
            }
          } else {
            conditionValue = null;
          }
        } else {
          conditionValue = this.formData[attr]["value"] ? this.formData[attr]["value"] : null;
        }
        if (
          this.formData[attr]?.searchCfgVo?.ifPrimarySearch &&
          this.computedTreeSearch &&
          this.primarySearchValue
        ) {          
          searchParams.push(this.primarySearchValue);
        } else {
          searchParams.push({
            conditionValue: conditionValue,
            matchPattern: this.formData[attr].matchPattern,
            propertyName: this.formData[attr].propertyName,
            propertyPath: this.formData[attr].propertyNamePath,
            propertyType: this.formData[attr].propertyType,
            propertyViewName: this.formData[attr].viewName
          });
        }
      }
    }

    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getTableData(),
        method: "post",
        data: {
          ifPage: this.hasFooter,
          pageSize: this.events.pageSize,
          searchParams: searchParams,
          startPage: this.events.current,
          viewDisplayConfId: this.package.viewConfig.viewDisplayConfId,
          viewConfigId: this.package.viewConfig.viewConfigId
        }
      });
      if (!success) {
        this.$message.error("查询表格数据失败:" + message);
      }
      let tableThead: any = [],
        tableData: any = [],
        excelHeaders: any = [];
      if (data) {
        if (data.colunmsInfo && data.colunmsInfo.length && data.colunmsInfo.length > 0) {
          data.colunmsInfo.map((item: any) => {
            tableThead.push({
              value: item.propertyName,
              label: item.viewName || item.colunmName,
              width: item.colunmWidth,
              columnHigh: item.columnHigh,
              titleCorlor: item.titleCorlor,
              alignment: item.alignment || "left",
              dataProType: item.dataProType,
              dataPro: item.dataPro,
              dataProFormat: item.dataProFormat,
              propertyType: item.propertyType,
              extendField: item.extendField
            });
            excelHeaders.push({
              //导出excel的表头
              property: item.propertyName,
              label: item.viewName || item.colunmName
            });
          });
          // 如果是有流程表单，则显示流程状态
          if (
            data?.rowsInfo?.records?.length > 0 &&
            data?.rowsInfo?.records[0]?.flowStatusCode !== 4
          ) {
            tableThead.push({
              dataProType: 0,
              value: "flowStatus",
              label: "流程状态",
              width: "100px",
              alignment: "left"
            });
            excelHeaders.push({
              property: "flowStatus",
              label: "流程状态"
            });
          }
        }
        if (
          data.rowsInfo &&
          data.rowsInfo.records &&
          data.rowsInfo.records.length &&
          data.rowsInfo.records.length > 0
        ) {
          data.rowsInfo.records.map((row: any) => {
            const rowData: any = {
              businessId: row.businessId,
              flowStatusCode: row.flowStatusCode
            };
            row.fieldDataVos.map((field: any) => {
              if (field.propertyType === "date") {
                rowData[field.propertyName] = field.viewValue ? field.viewValue : "";
              } else if (field.propertyType === "dateScope") {
                if (field.viewValue) {
                  let splitText: any = field.viewValue.split(";");
                  rowData[field.propertyName] = splitText[1] + " 至 " + splitText[2];
                } else {
                  rowData[field.propertyName] = field.viewValue;
                }
              } else if (field.propertyType === "boolean") {
                rowData[field.propertyName] = field.viewValue === 1 ? "是" : "否";
              } else {
                rowData[field.propertyName] = field.viewValue ? field.viewValue : "";
              }
              rowData.businessId = field.businessId;
              rowData.currentHandlerId = field.currentHandlerId;
              rowData.flowStatusCode = field.flowStatusCode;
              rowData.flowStatus = field.flowStatus;
              rowData.proTaskId = field.proTaskId;
              rowData.todoTaskName = field.todoTaskName;
              rowData.todoUtKey = field.todoUtKey;
            });
            rowData.ifDownloadAttZip = row.ifDownloadAttZip;
            tableData.push(rowData);
          });
        }
      }
      this.tableData = tableData;
      if (this.tableData.length > 0) {
        if (this.tableData[0].flowStatusCode === 4) {
          tableThead.pop();
          excelHeaders.pop();
        }
      }
      this.tableThead = tableThead;
      this.excelHeaders = excelHeaders;
      this.events.total = data && data.rowsInfo ? data.rowsInfo.total : 0;
      if (this.isFirstIn) {
        this.checkedList = JSON.parse(JSON.stringify(this.list));
        this.isFirstIn = false;
      }
      this.labelKey = this.tableThead[0]?.value;
      this.isShow = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.timer = setInterval(() => {
            if (this.$refs.szgcFormTable) {
              if (this.type === "view") {
                this.setRowCheck();
              }
              (this.$refs.szgcFormTable as any).doLayout();
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 300);
        });
      });
    } catch (error: any) {
      this.$message.error("查询表格数据失败:" + error);
    }
  }

  /*设置行选中*/
  setRowCheck() {
    if (this.$refs.szgcFormTable) {
      (this.$refs.szgcFormTable as any).clearSelection();
      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.checkedList.length; j++) {
          if (this.tableData[i].businessId === this.checkedList[j].businessId) {
            (this.$refs.szgcFormTable as any).toggleRowSelection(this.tableData[i], true);
          }
        }
      }
    }
  }

  /*控制表格全选展示*/
  cellClass(row: any) {
    let className = "";
    if (this.tableThead[0] && this.tableThead[0].columnHigh) {
      className += "custom-height ";
    }
    if (row.columnIndex === 0 && this.type === "view") {
      className += "disabledCheck";
    }

    return className;
  }

  formatHeaderCell({ columnIndex }: { [p: string]: any }) {
    const offset = Number(this.isSelection);
    if (this.tableThead.length && columnIndex > offset) {
      return {
        // "background-color":
        //   (this.tableThead[columnIndex - offset - 1]?.titleCorlor || "var(--szgc-element-primary)"),
        height: this.tableThead[0].columnHigh + "px"
      };
    }
  }

  formatCellStyle() {
    if (this.tableThead.length) {
      return {
        height: this.tableThead[0].columnHigh + "px"
      };
    }
  }

  /*单选行*/
  handleSelectionChange(selection: any[], row: any) {
    this.selections = selection;
    if (this.selections.find((item) => item.businessId === row.businessId)) {
      if (!this.checkedList.find((item) => item.businessId === row.businessId)) {
        this.checkedList.push({
          label: row[this.labelKey],
          businessId: row.businessId
        });
      }
    } else {
      //取消选中
      this.checkedList = this.checkedList.filter((item) => item.businessId !== row.businessId);
    }
  }

  /*删除已选项*/
  delView(businessId: string) {
    this.checkedList = this.checkedList.filter((item) => item.businessId !== businessId);
    this.setRowCheck();
  }

  /*时间转换*/
  dateFormat(date: any, extendField: string) {
    if (date) {
      return dateFormat(date, extendField || "YYYY-MM-DD");
    } else {
      return "--";
    }
  }

  /*公式转换*/
  formulaFormat(column: any, row: any) {
    const reg = /\$\{.*?\}/g;
    let str: string = "";
    column.dataPro.replace(reg, (match: string) => {
      const filed = match.substring(2, match.length - 1);
      if (row["" + filed]) {
        str += row["" + filed];
      } else {
        str += "";
      }
    });
    return str;
  }

  /*自定义*/
  defineDataFormat(column: any, row: any, index?: any) {
    try {
      let func: any;
      eval("func = " + column.dataProFormat) as any; //eval(column.dataProFormat + "(row, index)")
      return func(row, index);
    } catch (error: any) {
      return "";
    }
  }

  /*重置搜索条件*/
  async resetSearch() {
    if (this.showSearch) {
      this.toggleEvt();
    }
    await this.getViewInfo();
  }

  /*点击搜索按钮*/
  async searchEvt() {
    if (this.showSearch) {
      this.toggleEvt();
    }
    await this.getTableData();
  }

  /*展开/收起*/
  toggleEvt() {
    this.showSearch = !this.showSearch;
    if (this.showSearch) {
      this.leftHeight = "auto";
    } else {
      // const searchHeight: any = (
      //   this.$refs.pltTableSearch as HTMLDivElement
      // ).getBoundingClientRect();
      this.leftHeight = this.searchItemHeight + 2 + "px";
    }
  }

  /*每页条数改变*/
  async pageSizeHandler(pageSize: number | string) {
    this.events.pageSize = pageSize;
    this.events.current = 1;
    this.getTableData();
  }

  /*当前页改变*/
  async currentPageHandler(current: number | string) {
    this.events.current = current;
    this.getTableData();
  }

  /*plt-select*/
  pltSelectEvt(item: any, filedName: any) {
    this.nowInputItem = item;
    this.nowInputFileName = filedName;

    if (this.nowInputItem.propertyType === "areas") {
      this.selectType = "area";
    } else if (this.nowInputItem.propertyType === "corporates") {
      this.selectType = "corporate";
    } else if (this.nowInputItem.propertyType === "departments") {
      this.selectType = "department";
    } else if (
      this.nowInputItem.propertyType === "dictionaries" ||
      this.nowInputItem.propertyType === "dictionary"
    ) {
      // 字典选择使用plt-select-new
      this.selectType = this.nowInputItem.propertyType;
      this.selected = this.formData[this.nowInputFileName].valueText;
      this.selectedDict = this.formData[this.nowInputFileName].valueText.split(",").filter(Boolean);
      this.limiter = item.configValue || "";
      this.selectConditions = [{ key: "tendId", value: this.currentUser.tenId }];
      this.showSelectComponent = true;
      const limiter = JSON.parse(this.nowInputItem.configValue || "{}");
      this.selectComponentCode = limiter.value || "";
      return;
    } else if (this.nowInputItem.propertyType === "posts") {
      this.selectType = "post";
    } else if (this.nowInputItem.propertyType === "roles") {
      this.selectType = "role";
    } else if (this.nowInputItem.propertyType === "users") {
      this.selectType = "user";
    } else if (this.nowInputItem.propertyType === "selectors") {
      this.selectType = "selector";
    } else {
      this.selectType = this.nowInputItem.propertyType;
    }
    this.selected = this.formData[this.nowInputFileName].valueText;
    this.limiter = item.configValue || "";
    this.isSelectShow = true;
  }

  /*选择器选择*/
  selectModalEvt(data: any) {
    this.formData[this.nowInputFileName].valueText = data.valueText;
    this.formData[this.nowInputFileName].text = data.text;
    this.isSelectShow = false;
  }

  handleClearInput(propertyName: string) {
    this.formData[propertyName].valueText = "";
    this.formData[propertyName].text = "";
  }

  /*新增前置弹窗*/
  async addTableModal() {
    if (this.showSearch) {
      this.toggleEvt();
    }
    this.flowConfigId = "";
    this.processType = "mine";
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getViewInfo(this.package.viewConfig.viewDisplayConfId),
        method: "get"
      });
      if (!success) {
        this.$message.error("查询视图基本信息失败:" + message);
      }
      let temp: any = [];
      if (data) {
        if (data.flowCfgVos && data.flowCfgVos.length && data.flowCfgVos.length > 0) {
          temp = data.flowCfgVos;
        }
        this.flowList = temp;
        this.flowConfigId = this.flowList[0].flowConfigId;
        if (this.flowList.length > 1) {
          //大于一个流程id让选择
          this.preShow = true;
        } else {
          this.showAddModal();
        }
      } else {
        this.$message.error("查询视图基本信息失败:" + message);
      }
    } catch (error: any) {
      this.$message.error("查询视图基本信息失败:" + error);
    }
  }

  /*新增表格数据弹窗-根据有无流程来确定调用哪个表单，有流程走之前工作台的发起*/
  async showAddModal() {
    if (this.ifProcess) {
      this.showProcessModal();
    } else {
      this.modalTitle = "新增表单";
      this.modalData = {
        type: "add",
        data: null,
        flowConfigId: this.flowConfigId,
        packageType: this.package.packageInfo.packageType,
        dataViewCfgId: this.package.viewConfig.viewDisplayConfId,
        ifProcess: this.package.packageInfo.ifProcess
      };
      this.modalShow = true;
    }
  }

  /*详情弹窗*/
  detailModal(row: any) {
    if (this.ifProcess) {
      //有流程
      this.processDetail = {
        businessId: row.businessId
      };
      this.proDetailShow = true;
    } else {
      //无流程
      this.modalTitle = "表单详情";
      this.modalData = {
        type: "detail",
        data: row,
        dataViewCfgId: this.package.viewConfig.viewDisplayConfId,
        dataConfigId: this.package.viewConfig.viewConfigId,
        ifProcess: this.package.packageInfo.ifProcess,
        pacId: this.package.packageInfo.pacId,
        packageType: this.package.packageInfo.packageType,
        reqToken: this.package.reqToken
      };
      this.modalShow = true;
    }
  }

  /*有流程修改*/
  updateProModal(row: any) {
    if (row.flowStatusCode === 0) {
      //待发
      this.processType = "wait";
      this.flowInfo = {
        businessId: row.businessId
      };
    } else {
      //待办(处理中)
      this.processType = "todo";
      this.flowInfo = {
        businessId: row.businessId,
        taskId: row.proTaskId
      };
    }
    this.processShow = true;
  }

  /*无流程修改弹窗*/
  updateModal(row: any) {
    this.modalTitle = "处理表单";
    this.modalData = {
      type: "update",
      data: row,
      dataViewCfgId: this.package.viewConfig.viewDisplayConfId,
      dataConfigId: this.package.viewConfig.viewConfigId,
      ifProcess: this.package.packageInfo.ifProcess,
      pacId: this.package.packageInfo.pacId,
      reqToken: this.package.reqToken
    };
    this.modalShow = true;
  }

  /*无流程弹窗关闭*/
  modalEvt(data: any) {
    this.modalShow = false;
    if (data.type === "sure") {
      this.getTableData();
    }
  }

  /*流程弹窗*/
  async showProcessModal() {
    this.processTitle = "流程处理";
    this.flowInfo = {
      pacId: this.package.packageInfo.pacId,
      businessId: this.flowConfigId
    };
    this.processShow = true;
  }

  /*流程弹窗关闭*/
  processModalEvt() {
    this.processShow = false;
    this.getTableData();
  }

  /*删除表格数据*/
  async delTableData(row: any) {
    let confirm;
    try {
      confirm = await this.$confirm(`确认删除该条数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      });
    } catch (e) {
      confirm = null;
    }
    if (!confirm) {
      return false;
    }
    try {
      const { success, message } = await request({
        url:
          this.prefix +
          Api.delTableData({
            dataViewCfgId: this.package.viewConfig.viewDisplayConfId,
            businessId: row.businessId
          }),
        method: "delete"
      });
      if (!success) {
        this.$message.error("删除视图数据失败:" + message);
        return false;
      }
      this.$message.success("删除视图数据成功");
      await this.getTableData();
    } catch (error: any) {
      this.$message.error("删除视图数据失败:" + error);
    }
  }

  /*导出*/
  downLoadEvt() {
    if (this.tableData.length === 0) {
      return this.$message.error("暂无数据导出");
    }
    if (this.$refs.szgcFormTable) {
      const selection: any = (this.$refs.szgcFormTable as any).selection;
      if (selection.length > 0) {
        this.downLoadPart(selection);
      } else {
        this.downLoadAll();
      }
    } else {
      this.downLoadAll();
    }
  }

  /*导出当前页*/
  async downLoadPart(selection: any) {
    const datas: any = [];
    for (let i = 0; i < selection.length; i++) {
      const excelItem: any = {};
      for (let j = 0; j < this.tableThead.length; j++) {
        if (this.tableThead[j].value in selection[i]) {
          //存在属性
          if (this.tableThead[j].dataProType === 0) {
            if (this.tableThead[j].propertyType === "date") {
              excelItem[this.tableThead[j].value] = this.dateFormat(
                selection[i][this.tableThead[j].value],
                this.tableThead[j].extendField
              );
            } else {
              excelItem[this.tableThead[j].value] =
                selection[i][this.tableThead[j].value] === null
                  ? ""
                  : selection[i][this.tableThead[j].value];
            }
          } else if (this.tableThead[j].dataProType === 1) {
            excelItem[this.tableThead[j].value] = this.formulaFormat(
              this.tableThead[j],
              selection[i]
            );
          } else {
            excelItem[this.tableThead[j].value] = this.defineDataFormat(
              this.tableThead[j],
              selection[i],
              i
            );
          }
        }
      }
      datas.push(excelItem);
    }
    this.exportDialog.show({
      headers: this.excelHeaders,
      data: datas,
      fileName: this.package.viewConfig.viewName
    });
  }

  /*导出全部数据*/
  async downLoadAll() {
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.getTableData(),
        method: "post",
        data: {
          ifPage: false,
          pageSize: this.events.pageSize,
          searchParams: [],
          startPage: this.events.current,
          viewDisplayConfId: this.package.viewConfig.viewDisplayConfId,
          viewConfigId: this.package.viewConfig.viewConfigId
        }
      });
      if (!success) {
        this.$message.error("查询表格数据失败:" + message);
      }
      let tableData: any = [],
        datas: any = [];
      if (data) {
        if (
          data.rowsInfo &&
          data.rowsInfo.records &&
          data.rowsInfo.records.length &&
          data.rowsInfo.records.length > 0
        ) {
          data.rowsInfo.records.map((row: any) => {
            const rowData: any = {};
            row.fieldDataVos.map((field: any) => {
              if (field.propertyType === "date") {
                rowData[field.propertyName] = field.viewValue ? field.viewValue : "";
              } else if (field.propertyType === "dateScope") {
                if (field.viewValue) {
                  let splitText: any = field.viewValue.split(";");
                  rowData[field.propertyName] = splitText[1] + " 至 " + splitText[2];
                } else {
                  rowData[field.propertyName] = field.viewValue;
                }
              } else if (field.propertyType === "boolean") {
                rowData[field.propertyName] = field.viewValue === 1 ? "是" : "否";
              } else {
                rowData[field.propertyName] = field.viewValue ? field.viewValue : "";
              }
            });
            rowData.flowStatus = row.fieldDataVos[0].flowStatus;
            tableData.push(rowData);
          });
        }
      }
      for (let i = 0; i < tableData.length; i++) {
        const excelItem: any = {};
        for (let j = 0; j < this.tableThead.length; j++) {
          if (this.tableThead[j].value in tableData[i]) {
            //存在属性
            if (this.tableThead[j].dataProType === 0) {
              if (this.tableThead[j].propertyType === "date") {
                excelItem[this.tableThead[j].value] = this.dateFormat(
                  tableData[i][this.tableThead[j].value],
                  this.tableThead[j].extendField
                );
              } else {
                excelItem[this.tableThead[j].value] =
                  tableData[i][this.tableThead[j].value] === null
                    ? ""
                    : tableData[i][this.tableThead[j].value];
              }
            } else if (this.tableThead[j].dataProType === 1) {
              excelItem[this.tableThead[j].value] = this.formulaFormat(
                this.tableThead[j],
                tableData[i]
              );
            } else {
              excelItem[this.tableThead[j].value] = this.defineDataFormat(
                this.tableThead[j],
                tableData[i],
                i
              );
            }
          }
        }
        datas.push(excelItem);
      }
      this.exportDialog.show({
        headers: this.excelHeaders,
        data: datas,
        fileName: this.package.viewConfig.viewName
      });
    } catch (error: any) {
      this.$message.error("查询表格数据失败:" + error);
    }
  }

  /*下载附件*/
  async downLoad(row: any) {
    if (!row.ifDownloadAttZip) {
      return false;
    }
    let url: string = "";
    if (this.prefix) {
      url = `${this.prefix}/${Api.downLoadFiles({
        viewDisplayConfId: this.package.viewConfig.viewDisplayConfId,
        businessId: row.businessId
      })}`;
    } else {
      url = `${window.location.origin}/${Api.downLoadFiles({
        viewDisplayConfId: this.package.viewConfig.viewDisplayConfId,
        businessId: row.businessId
      })}`;
    }
    window.open(url, "_self");
  }

  /*type=view情况下确定/取消*/
  getViewList(flag: boolean) {
    if (this.checkedList && this.checkedList.length && this.checkedList.length > 0) {
      this.$emit("getViewList", { flag, data: this.checkedList });
    } else {
      this.$message.error("请选择视图数据");
    }
  }
}
